/*
 * Revelar no scroll.
 *
 * Cada elemento com [data-revelar] ganha a classe .yasy-revelado quando entra
 * em cena. O estado inicial vem do CSS sob `.yasy-anima`, classe posta por um
 * script inline antes da pintura.
 *
 * A checagem é feita na rolagem (com rAF para não pesar) e não só por
 * IntersectionObserver. Motivo: o observador se mostrou pouco confiável em
 * páginas onde a seção é a primeira do documento — ele simplesmente não
 * disparava, e conteúdo abaixo da dobra ficava invisível para sempre. Como o
 * estado inicial é `opacity: 0`, a falha aqui não custa uma animação: custa a
 * página. Então o mecanismo precisa ser previsível.
 */
(function () {
  'use strict';

  /* precisa entrar 12% da altura da janela, não só encostar */
  var MARGEM = 0.12;
  var funcionou = false;

  function revelar(no) { no.classList.add('yasy-revelado'); }

  function pendentes() {
    return document.querySelectorAll('[data-revelar]:not(.yasy-revelado)');
  }

  function iniciar() {
    var nos = document.querySelectorAll('[data-revelar]');
    if (!nos.length) return;

    var reduzido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduzido) {
      Array.prototype.forEach.call(nos, revelar);
      return;
    }

    var agendado = false;

    function checar() {
      agendado = false;
      funcionou = true;
      var restantes = pendentes();
      var limite = window.innerHeight * (1 - MARGEM);

      Array.prototype.forEach.call(restantes, function (no) {
        var r = no.getBoundingClientRect();
        /* Já passou pelo topo ou entrou o suficiente pela base. */
        if (r.top < limite && r.bottom > 0) revelar(no);
      });

      if (!pendentes().length) desligar();
    }

    function agendar() {
      if (agendado) return;
      agendado = true;
      window.requestAnimationFrame(checar);
    }

    function desligar() {
      window.removeEventListener('scroll', agendar);
      window.removeEventListener('resize', agendar);
    }

    window.addEventListener('scroll', agendar, {passive: true});
    window.addEventListener('resize', agendar);

    checar();
    /* Depois das fontes e das imagens o layout muda de altura; recheca. */
    window.addEventListener('load', agendar);
    setTimeout(agendar, 600);
  }

  /*
   * Piso de segurança — só entra em cena se a máquina acima nunca girou.
   *
   * O estado inicial `opacity: 0` vale só sob `.yasy-anima` no <html>. Se
   * `checar()` não tiver rodado nenhuma vez em 3 segundos, a classe sai e tudo
   * fica visível: perder a animação é aceitável, perder o conteúdo não. Quando
   * a máquina está girando o piso não faz nada, para não estragar a revelação
   * de quem ainda está longe da dobra.
   *
   * Além de tirar a classe, o piso força os valores finais no elemento: uma
   * transição pode ficar presa (aba em segundo plano, por exemplo) e o estilo
   * inline é o único jeito de encerrá-la.
   */
  function piso() {
    if (funcionou) return;
    document.documentElement.classList.remove('yasy-anima');
    Array.prototype.forEach.call(document.querySelectorAll('[data-revelar]'), function (no) {
      revelar(no);
      no.style.transition = 'none';
      no.style.opacity = '1';
      no.style.transform = 'none';
    });
  }

  setTimeout(piso, 3000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
